import type { NavItem, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'MultiScreen Video Studio',
    shortName: 'MultiScreen',
    tagline: 'Many videos. One screen.',
    description: "Play, compare and organize videos and photos on one Android screen. Free 1, 2 and 4-view grids, up to 12 views with PRO, MP4 export and Google TV.",
    url: getOrigin()
}

export const appLinks = {
    playStore: 'https://play.google.com/store/apps/details?id=com.syncgrid.videoplayer',
    subscriptions: 'https://play.google.com/store/account/subscriptions',
    supportEmail: 'soporte.multiscreen@gmail.com',
    privacy: 'https://multiscreen-video-studio.web.app/privacy.html',
    terms: 'https://multiscreen-video-studio.web.app/terms.html',
    planTerms: 'https://multiscreen-video-studio.web.app/terms.html#planes-y-recompensas',
    deleteAccount: 'https://multiscreen-video-studio.web.app/delete-account.html'
}

export const navItems: NavItem[] = [
    { label: 'Features', href: '#features' },
    { label: 'Use cases', href: '#use-cases' },
    { label: 'Google TV', href: '#google-tv' },
    { label: 'Free & PRO', href: '#pricing' }
]
